<form [formGroup]="requestForm">
  <div
    class="container-fluid pb-1 mx-auto"
    style="background-color: #567ba0; padding-left: 30px"
  >
    <div class="mx-auto">
      <p class="mb-0">
        <a
          [href]="'/home'"
          class="btn btn-xs text-light shadow-none align-middle px-0"
        >
          <img src="./assets/images/arrow-left.svg" width="18px" />
          Volver</a
        >
      </p>
      <h2 class="text-light mb-0 d-inline-block me-3">Ordenes de trabajo</h2>
      <button
        *ngIf="createButtonIsVisible"
        class="btn btn-success btn-sm d-inline-block mb-1 me-3"
        type="button"
        (click)="createNewWorkOrder()"
        [@buttonAnimation]
      >
        <i class="fas fa-plus me-1"></i> Crear nueva tarea
      </button>
      <button
        *ngIf="createBinnacleButtonIsVisible"
        class="btn btn-warning btn-sm d-inline-block mb-1"
        type="button"
        (click)="createOrUpdateBinnacle(null, 'Bitácora')"
        [@buttonAnimation]
      >
        <i class="fas fa-plus me-1"></i> Informe de trabajo
      </button>
      <div
        class="d-inline-block ms-3 p-3 border rounded float-end"
        style="background-color: #567ba0; border-color: #567ba0 !important"
        [@buttonAnimation]
      >
        <div class="d-inline-block me-3">
          <mdb-form-control
            class="custom-shadow rounded"
            style="background-color: aliceblue"
            [@buttonAnimation]
          >
            <input
              mdbValidate
              mdbInput
              type="text"
              class="form-control"
              placeholder="Desde"
              [mdbDatepicker]="fromPicker"
              formControlName="start_schedule_date"
            />
            <label mdbLabel class="form-label active"
              >Fecha program. (desde)</label
            >
            <mdb-datepicker-toggle
              [mdbDatepicker]="fromPicker"
            ></mdb-datepicker-toggle>
            <mdb-datepicker
              #fromPicker
              [options]="esOptions"
              [confirmDateOnSelect]="true"
            >
              <ng-template mdbDatepickerHeader>
                <div class="datepicker-header">
                  <div class="datepicker-title">
                    <span class="datepicker-title-text"
                      >Seleccione fecha desde</span
                    >
                  </div>
                  <div class="datepicker-date">
                    <span class="datepicker-date-text"
                      >{{ fromPicker.activeDay }}/{{
                        fromPicker.activeMonth + 1
                      }}/{{ fromPicker.activeYear }}</span
                    >
                  </div>
                </div></ng-template
              >
            </mdb-datepicker>
          </mdb-form-control>
        </div>

        <div class="d-inline-block me-3">
          <mdb-form-control
            class="custom-shadow rounded"
            style="background-color: aliceblue"
            [@buttonAnimation]
          >
            <input
              mdbValidate
              mdbInput
              type="text"
              class="form-control"
              placeholder="Hasta"
              [mdbDatepicker]="toPicker"
              formControlName="end_schedule_date"
            />
            <label mdbLabel class="form-label active"
              >Fecha program. (hasta)</label
            >
            <mdb-datepicker-toggle
              [mdbDatepicker]="toPicker"
            ></mdb-datepicker-toggle>
            <mdb-datepicker
              #toPicker
              [options]="esOptions"
              [confirmDateOnSelect]="true"
            >
              <ng-template mdbDatepickerHeader>
                <div class="datepicker-header">
                  <div class="datepicker-title">
                    <span class="datepicker-title-text"
                      >Seleccione fecha desde</span
                    >
                  </div>
                  <div class="datepicker-date">
                    <span class="datepicker-date-text"
                      >{{ toPicker.activeDay }}/{{
                        toPicker.activeMonth + 1
                      }}/{{ toPicker.activeYear }}</span
                    >
                  </div>
                </div></ng-template
              >
            </mdb-datepicker>
          </mdb-form-control>
        </div>
        <div class="d-inline-block me-3">
          <mdb-form-control
            class="custom-shadow rounded"
            style="background-color: aliceblue; width: 150px"
          >
            <mdb-select
              placeholder="Tipo"
              [filter]="true"
              formControlName="type"
            >
              <mdb-option [value]="null">Seleccione Tipo</mdb-option>
              <mdb-option *ngFor="let item of types" [value]="item.name">
                {{ item.name }}
              </mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label">Tipo</label>
          </mdb-form-control>
        </div>
        <button
          class="btn btn-info btn-sm d-inline-block mb-1"
          type="button"
          (click)="filterData()"
          [@buttonAnimation]
        >
          <i class="fas fa-filter me-1"></i> Filtrar
        </button>
      </div>
    </div>
  </div>
</form>
<form>
  <div class="datatable table-editor">
    <table
      class="table datatable-table"
      mdbTable
      mdbTableSort
      #table="mdbTable"
      #sort="mdbTableSort"
      [dataSource]="requestWorkOrders"
      [pagination]="pagination"
      [sort]="sort"
      width="100%"
    >
      <thead class="datatable-header">
        <tr>
          <ng-container *ngFor="let header of headers">
            <th
              [mdbTableSortHeader]="header.field"
              [disableSort]="header.disableSort"
              scope="col"
              class="py-2 align-middle th_3"
              style="white-space: normal"
            >
              <strong>{{ header.label.replace("_", " ") | titlecase }}</strong>
            </th>
          </ng-container>
        </tr>
      </thead>

      <tbody class="datatable-body">
        <tr *ngIf="loading">
          <td colspan="5" class="p-0 pt-1">
            <div class="px-2 bg-light py-5 text-center">
              <div
                width="150"
                class="spinner-border mt-5 opacity-50"
                role="status"
              ></div>
              <p class="lead text-muted text-center mb-5">
                Cargando resultados...
              </p>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody class="datatable-body">
        <tr
          *ngFor="let register of requestWorkOrders; let index = index"
          scope="row"
          [cdkTrapFocus]="editElementIndex === index"
          [cdkTrapFocusAutoCapture]="editElementIndex === index"
          [ngClass]="{ 'edited-row': editElementIndex === index }"
        >
          <td class="table-cell py-1 px-4" style="white-space: normal">
            <ng-container>
              <button
                class="btn btn-outline-success btn-sm w-50"
                type="button"
                [@buttonAnimation]
              >
                {{ register.ID }}
              </button>
            </ng-container>
          </td>
          <td
            class="table-cell py-1 px-4 text-center"
            style="white-space: normal"
          >
            <ng-container>
              <i
                *ngIf="register.COMPONENT_STOCK_VERIFICATION === '1'"
                class="fas fa-check text-success"
              ></i>
              <i
                *ngIf="register.COMPONENT_STOCK_VERIFICATION !== '1'"
                class="fas fa-times text-danger"
              ></i>
            </ng-container>
          </td>
          <td
            class="table-cell py-1 px-4 text-center"
            style="white-space: normal"
          >
            <ng-container>
              <i
                *ngIf="register.IS_NECESARY_STOP_LINE === '1'"
                class="fas fa-check text-success"
              ></i>
              <i
                *ngIf="register.IS_NECESARY_STOP_LINE !== '1'"
                class="fas fa-times text-danger"
              ></i>
            </ng-container>
          </td>
          <td class="table-cell py-1 px-4" style="white-space: normal">
            <ng-container>
              {{ register.SCHEDULE_DATE }}
            </ng-container>
          </td>
          <td class="table-cell py-1 px-4" style="white-space: normal">
            <ng-container>
              {{
                register.COMMENTS_TO_WAREHOUSE != "null"
                  ? register.COMMENTS_TO_WAREHOUSE
                  : ""
              }}
            </ng-container>
          </td>
          <td class="table-cell py-1 px-4">
            <ng-container>
              {{ register.created_at }}
            </ng-container>
          </td>
          <td class="table-cell text-center py-1 px-4">
            <ng-container>
              <button
                *ngIf="register.STATUS === '1'"
                class="btn btn-info btn-sm w-100"
                type="button"
                [@buttonAnimation]
              >
                Registrada por planificador
              </button>
              <button
                *ngIf="register.STATUS === '2'"
                class="btn btn-success btn-sm w-100"
                type="button"
                [@buttonAnimation]
              >
                Validada por bodega
              </button>
              <button
                *ngIf="register.STATUS === '3'"
                class="btn btn-warning btn-sm w-100"
                type="button"
                [@buttonAnimation]
              >
                Ejecutada por mantención
              </button>
            </ng-container>
          </td>
          <td class="table-cell text-center py-1 px-4">
            <ng-container>
              <button
                *ngIf="register.TYPE === 'Preventivo'"
                class="btn btn-warning btn-sm w-100"
                type="button"
                [@buttonAnimation]
              >
                {{ register.TYPE }}
              </button>
              <button
                *ngIf="register.TYPE === 'Correctivo'"
                class="btn btn-danger btn-sm w-100"
                type="button"
                [@buttonAnimation]
              >
                {{ register.TYPE }}
              </button>
              <button
                *ngIf="register.TYPE === 'Bitácora'"
                class="btn btn-primary btn-sm w-100"
                type="button"
                [@buttonAnimation]
              >
                {{ register.TYPE }}
              </button>
            </ng-container>
          </td>
          <td class="table-cell py-1 px-4">
            <button
              *ngIf="seeButtonIsVisible"
              class="btn btn-info btn-sm me-1"
              type="button"
              (click)="seeWorkOrder(register.ID)"
              [@buttonAnimation]
            >
              <i class="far fa-eye"></i>
            </button>
            <button
              *ngIf="validateBinnacleButtonIsVisible"
              class="btn btn-warning btn-sm me-1"
              type="button"
              [disabled]="register.STATUS != '1'"
              (click)="updateByWarehouse(register.ID)"
              [@buttonAnimation]
            >
              <i class="fas fa-warehouse"></i>
            </button>
            <button
              *ngIf="addMaintenanceToOTButtonIsVisible"
              class="btn btn-success btn-sm me-1"
              [disabled]="register.STATUS === '3'"
              type="button"
              (click)="createOrUpdateBinnacle(register.ID, 'Preventivo')"
              [@buttonAnimation]
            >
              <i class="fas fa-tools"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <mdb-table-pagination
      #pagination
      rowsPerPageText="Registros por Página"
      ofText="de"
      [disabled]="loading"
      (paginationChange)="onPageChange($event)"
    ></mdb-table-pagination>
  </div>
</form>

<mdb-loading [show]="loadingFull" [fullscreen]="true">
  <div class="loading-spinner">
    <div class="spinner-border loading-icon" role="status"></div>
    <span class="loading-text">Cargando datos...</span>
  </div>
</mdb-loading>
